module.exports = __webpack_public_path__ + "media/application/images/icons/print-solid-51bb1f0025e521d8a8db7a5de4d7d62f.svg";